exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit {\n  font-family: sans-serif;\n  font-size: 0.8em;\n  font-weight: light;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n}\n\n#aa-video-ad-unit .clickable {\n  cursor: pointer;\n}\n\n#aa-video-ad-unit .full {\n  position: absolute;\n  left: 0; right: 0;\n  top: 0; bottom: 0;\n  margin: auto;\n}\n\n#aa-video-ad-unit .clickthru {\n  z-index: 0;\n}\n\n#aa-video-ad-unit .icons {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  z-index: 1;\n}\n\n#aa-video-ad-unit .icons li {\n  display: inline-block;\n  cursor: pointer;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/DisplaySettings.css
// module id = 161
// module chunks = 6